import type { RequestResponse } from '@/types/publicType'
import type {
  userInfoInterface,
  countryInterface,
  languageInterface,
  followingInterface,
  fansInterface,
  levelExperienceInterface
} from '@/types/apiType/userType'

/**
 * 获取用户信息
 * @param {string} queryUid
 */
export function apiGetUserInfo(params: {
  queryUid: string | number
}): Promise<RequestResponse<userInfoInterface>> {
  return getFetchData({
    url: '/user/web/get',
    method: 'GET',
    params
  })
}

/**
 * 注销登录
 * @param {string} queryUid
 */
export function apiLogout(data: { access_token: string }) {
  return getFetchData({
    url: '/acc/web/logout',
    method: 'POST',
    data
  })
}

/**
 * 编辑个人信息
 * @param {string} avatar
 * @param {string} birth
 * @param {string} country
 * @param {string} nick
 * @param {string} userDesc
 */
export function apiUpdateUserInfo(data: {
  avatar?: string
  birth: string
  country: string
  nick: string
  userDesc: string
}) {
  return getFetchData({
    url: '/h5/u/web/update',
    method: 'POST',
    data,
    loading: true
  })
}

/**
 * 获取国家列表
 */
export function apiGetCountryList(): Promise<
  RequestResponse<countryInterface[]>
> {
  return getFetchData({
    url: '/h5/u/country',
    method: 'GET'
  })
}

/**
 * 获取语言列表
 */
export function apiGetLanguageList(): Promise<
  RequestResponse<languageInterface[]>
> {
  return getFetchData({
    url: '/h5/u/languageList',
    method: 'GET'
  })
}

/**
 * 关注
 * @param {number} likedUid
 * @param {number} type 1关注2取消关注
 */
export function apiRelationLike(data: {
  likedUid: number
  type: number
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/relation/like',
    method: 'POST',
    data
  })
}

/**
 * 举报
 * @param {number} reportType 1政治2色情3广告4人身
 * @param {number} type 1政治2色情3广告4人身
 * @param {number} reportUid
 */
export function apiReport(data: {
  reportType: number | string
  type: number
  reportUid: number
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/u/tipOff',
    method: 'POST',
    data
  })
}

/**
 * 更新语言
 * @param {string} updateLanguage 要修改的值
 * @param {1} type 1为更新第一语言
 */
export function apiUpdateLanguage(data: {
  updateLanguage: string
  type: 1
}): Promise<RequestResponse<languageInterface[]>> {
  return getFetchData({
    url: '/h5/u/update/current/language',
    method: 'POST',
    data
  })
}

/**
 * 获取好友列表
 */
export function apiGetFriends(
  params: {
    pageNum: number
    pageSize: number
  },
  loading = false
): Promise<RequestResponse<Array<followingInterface>>> {
  return getFetchData({
    url: '/h5/relation/attention/friends',
    method: 'GET',
    params,
    loading
  })
}

/**
 * 获取粉丝列表
 */
export function apiGetFans(
  params: {
    pageNum: number
    pageSize: number
  },
  loading = false
): Promise<RequestResponse<fansInterface>> {
  return getFetchData({
    url: '/h5/relation/fanslist',
    method: 'GET',
    params,
    loading
  })
}

/**
 * 获取关注列表
 */
export function apiGetFollowing(
  params: {
    pageNum: number
    pageSize: number
  },
  loading = false
): Promise<RequestResponse<Array<followingInterface>>> {
  return getFetchData({
    url: '/h5/relation/following',
    method: 'GET',
    params,
    loading
  })
}

/**
 * 黑名单操作
 * @param {number} account 目标用户uid
 * @param {1|2} is_add 1=添加、0=移除
 * @param {number} room_id 房间id
 */
export function apiImRoomMarkRoomBlack(data: {
  account: number
  room_id: number
  is_add: 1 | 0
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/chic/h5/room/markChatRoomBlackList',
    method: 'POST',
    data
  })
}

/**
 * 获取用户等级经验
 * @param {3|6} type 3:财富等级
 */
export function apiGetUserLevelExperience(params: {
  type: 3 | 6
}): Promise<RequestResponse<levelExperienceInterface>> {
  return getFetchData({
    url: '/h5/l/exeperience/get',
    method: 'GET',
    params
  })
}

/**
 * 图灵盾
 * @param {string} token 图灵盾deviceToken
 * @param {string} iosUdid IOS的UDID
 */
export function apiUserH5turingShield(params: {
  token: string
  iosUdid: string
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/user/h5/turingShield',
    method: 'GET',
    params
  })
}

/**
 * 实名认证
 * @param {string} pic 照片
 */
export function apiWithDrawCheckFaceSimilarity(data: {
  pic: string
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/withDraw/checkFaceSimilarity',
    method: 'POST',
    data,
    isCloseTost: true
  })
}

/**
 * 校验人脸是否已经校验过
 */
export function apiWithIsDrawCheckFaceSimilarity(): Promise<
  RequestResponse<void>
> {
  return getFetchData({
    url: '/withDraw/isCheckFaceSimilarity',
    method: 'GET',
    loading: true
  })
}
